export const NO_BACKGROUND = false;
